var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tile',{attrs:{"position":_vm.position,"no-fade":""}})}
var staticRenderFns = []

export { render, staticRenderFns }